// errorLogger.js — place in src/utils/
// Works in both aurora-website (React) and aurora-loyalty (Next.js)

const API_BASE = typeof process !== 'undefined'
  ? (process.env.REACT_APP_API_URL || process.env.NEXT_PUBLIC_API_URL || 'https://api.auroragh.com/api')
  : 'https://api.auroragh.com/api';

const APP_VERSION = typeof window !== 'undefined'
  ? (window.location.hostname.includes('app.') ? 'dashboard' : 'website')
  : 'unknown';

// Core log function
export const logError = async (error, componentName = null, severity = 'ERROR') => {
  try {
    const userRaw = typeof localStorage !== 'undefined'
      ? localStorage.getItem('aurora_user') : null;
    const userEmail = userRaw ? JSON.parse(userRaw)?.email : null;

    await fetch(`${API_BASE}/errors/report`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        errorMessage: error?.message || String(error),
        stackTrace: error?.stack || null,
        pageUrl: typeof window !== 'undefined' ? window.location.href : null,
        componentName,
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
        userEmail,
        severity,
        appVersion: APP_VERSION,
      }),
    });
  } catch (e) {
    // Never throw — logging should never break the app
    console.warn('[ErrorLogger] Failed to log error:', e);
  }
};

// Global error handler — call once in App.js / layout.tsx
export const initGlobalErrorLogging = () => {
  if (typeof window === 'undefined') return;

  // Uncaught JS errors
  window.onerror = (message, source, lineno, colno, error) => {
    logError(
      error || { message: `${message} (${source}:${lineno}:${colno})`, stack: null },
      'window.onerror',
      'CRITICAL'
    );
    return false; // Don't suppress the error
  };

  // Unhandled promise rejections
  window.onunhandledrejection = (event) => {
    logError(
      event.reason instanceof Error
        ? event.reason
        : { message: String(event.reason), stack: null },
      'unhandledrejection',
      'ERROR'
    );
  };
};

export default logError;